<template>
  <v-container fluid class="container_bg">

    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <template v-if="$i18n.locale == 'ko'">
          <h1>공통</h1>
        </template>
        <template v-else>
          <h1>Common</h1>
        </template>
      </v-col>
    </v-row>
    
    <v-divider/> 
    
    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <template v-if="$i18n.locale == 'ko'">
          <p>FAIRPASS API 공통규칙입니다.<br>모든 API는 <a href="https://www.postman.com/" target="_blank">POSTMAN</a>으로 검증되었습니다.</p>
        </template>
        <template v-else>
          <p>FAIRPASS API common rules.<br>All APIs are validated with <a href="https://www.postman.com/ " target="_blank">POSTMAN</a>.</p>
        </template>
      </v-col>
    </v-row>

    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <template v-if="$i18n.locale == 'ko'">
          FAIRPASS API는 모두 POST방식으로 통신하며 아래 주소를 HOST URL로 사용합니다.
        </template>
        <template v-else>
          The FAIRPASS API communicates in a POST manner and uses the address below as the HOST URL.
        </template>
      </v-col>
    </v-row>
    <v-row justify="center" dense>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">HOST URL</v-col>
      <v-col cols="12" md="8" class="fielddesc">https://api.fairpass.co.kr</v-col>
    </v-row>

    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h3>Request Header</h3>
        <template v-if="$i18n.locale == 'ko'">
          <p style="color:red">모든 API 요청은 Request Header에 ApiKey 값을 추가하여 보내주셔야합니다.</p>
        </template>
        <template v-else>
          <p style="color:red">All API requests must be sent by adding the ApiKey value to the Request Header.</p>
        </template>
      </v-col>
    </v-row>

    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <template v-if="$i18n.locale == 'ko'">
          <h3>Request Body(요청 파라메터)</h3>
          각 API 문서를 참고하여 요청 파라메터를 보내주세요.
        </template>
        <template v-else>
          <h3>Request Body</h3>
          Please refer to each API document and send the request parameter.          
        </template>
      </v-col>
    </v-row>
    
    
    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <template v-if="$i18n.locale == 'ko'">
          <h3>Response Body(응답)</h3>
          모든 응답은 아래 예시와 같은 JSON형태로 리턴합니다.
        </template>
        <template v-else>
          <h3>Response Body(응답)</h3>
          All responses are returned in the form of JSON, as shown in the example below.          
        </template>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="12" md="11" class="fieldname"><h4>JSON representation</h4></v-col>
      <v-col cols="12" md="11" class="fielddesc pa-0">
        <pre translate="no" style="background:#fafafa">
        {
          "resultCode": 0,
          "resultMsg": "",
          "resultData": [
            {
              ...
            },
            {
              ...
            },
        }          
        </pre>
      </v-col>
      
    </v-row>

    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <template v-if="$i18n.locale == 'ko'">
          <h3>ResultCode(응답코드)</h3>
          아래 코드표를 확인하여 resultCode에 따른 상황을 확인하세요
        </template>
        <template v-else>
          <h3>ResultCode (response code)</h3>
          Check the code table below to see the situation according to the resultCode          
        </template>
      </v-col>
    </v-row>
    <v-row justify="center" dense>
      <v-col cols="12" md="11" class="pa-0" align-center="center">
        <table>
          <tr><td width="10%" class="fieldtd" style="text-align:center">0</td><td width="90%">{{this.$i18n.locale == 'ko' ? '요청성공' : 'Request successful'}}</td></tr>
          <tr><td width="10%" class="fieldtd" style="text-align:center">1</td><td width="90%">{{this.$i18n.locale == 'ko' ? '요청 에러. 리턴된 resultMsg를 확인하세요' : 'Request error. Check returned resultMsg'}}</td></tr>
          <tr><td width="10%" class="fieldtd" style="text-align:center">9</td><td width="90%">{{this.$i18n.locale == 'ko' ? '파라메터 오류. 리턴된 resultMsg를 확인하세요' : 'Parameter error. Check returned resultMsg'}}</td></tr>
          <tr><td width="10%" class="fieldtd" style="text-align:center">94</td><td width="90%">{{this.$i18n.locale == 'ko' ? 'request Header에 ApiKey값이 없음.' : 'Request Header does not have an ApiKey value.'}}</td></tr>
          <tr><td width="10%" class="fieldtd" style="text-align:center">95</td><td width="90%">{{this.$i18n.locale == 'ko' ? '중복된 ApiKey(관리자에게 문의 필요)' : 'Duplicate ApiKey (requires administrator contact)'}}</td></tr>
          <tr><td width="10%" class="fieldtd" style="text-align:center">97</td><td width="90%">{{this.$i18n.locale == 'ko' ? '관리자에 의한 ApiKey 사용 중지' : 'ApiKey disabled by administrator'}}</td></tr>
          <tr><td width="10%" class="fieldtd" style="text-align:center">98</td><td width="90%">{{this.$i18n.locale == 'ko' ? '존재하지 않는 ApiKey' : 'ApiKey that doesn\'t exist'}}</td></tr>
          <tr><td width="10%" class="fieldtd" style="text-align:center">99</td><td width="90%">{{this.$i18n.locale == 'ko' ? 'ApiKey 인증 오류' : 'ApiKey Authentication Error'}}</td></tr>
        </table>
      </v-col>
    </v-row>



    <v-row justify="center" dense class="mt-15">
    </v-row>



  </v-container>
</template>
<script>

export default {

    mounted() {

    },

    data: () => ({

    }),

    methods: {

      test(){



      }

    },

    created(){
      //apiProductList
    }


}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

table{
  width: 100%;
  border-collapse: collapse;
}
th, td {
  border: 1px solid #eaeaea;
  padding: 10px;
}
.fieldtd {
  background: #f1f3f4;
}
.fieldname {
  background: #f1f3f4;
  border: 1px solid #eaeaea;
}
.fielddesc {
  border: 1px solid #eaeaea;
  padding-left: 15px;
  padding-right: 15px;
}

</style>